export interface ShippingRate {
  maxWeight: number;
  cost: number;
}

export type ShippingRates = Record<string, ShippingRate[]>;

declare global {
  interface Window {
    ekShippingRates?: ShippingRates;
  }
}

// Keep in sync with snippets/schema-offer-merchant-fields.liquid.
// ponytail: CH 5–10 kg was omitted from the rate sheet; same 14.99 as AT and the previous CH table.
export const SHIPPING_RATES: ShippingRates = {
  DE: [{ maxWeight: Infinity, cost: 0 }],
  EU: [
    { maxWeight: 2, cost: 9.99 },
    { maxWeight: 5, cost: 14.99 },
    { maxWeight: 10, cost: 19.99 },
    { maxWeight: 20, cost: 29.99 },
    { maxWeight: 30, cost: 49.99 },
    { maxWeight: 40, cost: 59.99 },
    { maxWeight: 60, cost: 69.99 },
    { maxWeight: 80, cost: 89.99 },
    { maxWeight: 120, cost: 120.0 },
  ],
  AT: [
    { maxWeight: 2, cost: 4.99 },
    { maxWeight: 5, cost: 9.99 },
    { maxWeight: 10, cost: 14.99 },
    { maxWeight: 20, cost: 19.99 },
    { maxWeight: 30, cost: 24.99 },
    { maxWeight: 40, cost: 29.99 },
    { maxWeight: 60, cost: 39.99 },
    { maxWeight: 80, cost: 49.99 },
    { maxWeight: Infinity, cost: 99.9 },
  ],
  CH: [
    { maxWeight: 2, cost: 4.99 },
    { maxWeight: 5, cost: 9.99 },
    { maxWeight: 10, cost: 14.99 },
    { maxWeight: 20, cost: 19.99 },
    { maxWeight: 30, cost: 24.99 },
    { maxWeight: 40, cost: 29.99 },
    { maxWeight: 60, cost: 39.99 },
    { maxWeight: 80, cost: 49.99 },
    { maxWeight: Infinity, cost: 99.9 },
  ],
};

export const mapCountryToGroup = (country: string): string => {
  const c = (country || "").toUpperCase();
  if (c === "DE" || c === "AT" || c === "CH") return c;
  return "EU";
};

export const calculateShippingCost = (country: string, weightKg: number): number => {
  const rates = SHIPPING_RATES[country];
  if (!rates) return 0;
  const applicable = rates.find((rate) => weightKg <= rate.maxWeight);
  return applicable ? applicable.cost : 0;
};

window.ekShippingRates = SHIPPING_RATES;
